(ns kyber.components.composite.rate
  (:require [clojure.string :as str]
            [re-frame.core :as re-frame]

            [kyber.styles.core :refer [gs styles->classes]]
            [kyber.i18n.core :as i18n]))

(def classes
  (styles->classes
   {:playback-rate-button
    {:background :none
     :border :none
     :cursor :pointer
     :font-size (gs [:font-size :caption-20])
     :user-select :none
     :color (gs [:colors :primary-lite-600])
     :width "50px"
     "&:focus" {:outline (gs [:spacing :p0])
                :border-image :none}

     (gs [:queries :hover])
     {"&:hover" {:color (gs [:colors :primary-lite-700])}}

     (gs [:queries :ie])
     {:padding-right (gs [:spacing :p36])}}}))

(defn render
  [{:keys [rate player-key]}]
  [:button
   (cond-> {:class (:playback-rate-button classes)}
     (some? rate)
     (assoc :on-click #(re-frame/dispatch [:media-player/adjust-playback-rate
                                           {:player-key player-key
                                            :rate       (condp = rate
                                                          0.75 1
                                                          1    1.25
                                                          1.25 0.75)}])))
   (i18n/t* ::rate-label {:rate (-> rate str (str/replace "." ""))})])
